import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'

import {CodeViewEditor} from '../components/CodeViewEditor'
import {codeViewNewRoute} from '../routes/code-view-new-route'
import {CodeView} from './CodeView'

export function CodeViewNewEntrypoint() {
  const {data: payload} = useRouteQuery(codeViewNewRoute, 'mainQuery')

  return (
    <div className="tmp-pt-3">
      <CodeView payload={payload} action="new">
        {() => (
          <CodeViewEditor
            editInfo={payload.editInfo}
            path={payload.path}
            webCommitInfo={payload.webCommitInfo}
            copilotInfo={payload.copilotInfo}
            copilotGenerateCommitMessageAuthInfo={payload.copilotGenerateCommitMessageAuthInfo}
          />
        )}
      </CodeView>
    </div>
  )
}
